export const MODERN_COLORS = {
  primary: '#0284c7',
  primaryDark: '#0369a1',
  primaryLight: '#38bdf8',
  primaryIce: '#f0f9ff',
  primaryIce2: '#e0f2fe',
  borderCyan: '#38bdf8',
  borderSoft: '#bae6fd',
  borderLight: '#e0f2fe',
  bgLight: '#f0f9ff',
  bgHeader: '#f8fafc',
  bgCard: '#ffffff',
  textMain: '#0f172a',
  textMuted: '#64748b',
  textSubtle: '#94a3b8',

  // Status tokens
  successBg: '#ecfdf5',
  successBorder: '#a7f3d0',
  successText: '#059669',
  successDark: '#065f46',

  warningBg: '#fffbeb',
  warningBorder: '#fde68a',
  warningText: '#d97706',
  warningDark: '#b45309',

  errorBg: '#fef2f2',
  errorBorder: '#fecaca',
  errorText: '#dc2626',
  errorDark: '#b91c1c',

  infoBg: '#f0f9ff',
  infoBorder: '#bae6fd',
  infoText: '#0284c7',
  infoDark: '#0369a1',
};

export const MODERN_SHADOWS = {
  card: '0 4px 16px -2px rgba(14, 165, 233, 0.05)',
  table: '0 10px 25px -5px rgba(14, 165, 233, 0.08), 0 4px 10px -2px rgba(14, 165, 233, 0.04)',
  tableHover: '0 14px 28px -4px rgba(14, 165, 233, 0.12), 0 6px 14px -2px rgba(14, 165, 233, 0.06)',
  floatingBar: '0 10px 30px -5px rgba(14, 165, 233, 0.15)',
  buttonPrimary: '0 2px 8px rgba(2, 132, 199, 0.25)',
};

export const MODERN_RADIUS = {
  pill: '50px',
  card: 3,
  table: 3,
  dialog: 3,
};
